import { atom } from 'recoil';

export const isExChangeTicket = atom({
    key: 'isExChangeTicket',
    default: false
});